<div class="parent-form">
  <mat-form-field [class.has-error]="dropDownControl.invalid && (dropDownControl.dirty || dropDownControl.touched)"
                  class="form-field-input selectClass mb-0">
    <mat-label>{{ title! | translate }}</mat-label>
    <mat-icon class="arrow-icon"
              matSuffix>
      <img src="/icons/arrow-down.svg">
    </mat-icon>
    <mat-select #select
                (selectionChange)="onSelectionChange($event)"
                [formControl]="dropDownControl"
                [multiple]="isMultiple"
                [placeholder]="(selectedOptions && selectedOptions.length > 0) ? (getSelectedLabels() ) : ('انتخاب نمایید...' | translate)"
                [required]="required!"
                no-keyboard-action
                panelClass="dropDown-seasons-panel">
      <mat-select-trigger>
        {{ (selectedOptions && selectedOptions.length > 0) ? (getSelectedLabels()) : ('انتخاب نمایید...' | translate) }}
      </mat-select-trigger>
      <div class="col-12 row mt-2">
        @for (selectedOption of selectedOptions; track $index) {
          <div class="notification d-flex align-items-center position-relative">
            <div class="d-flex align-items-center end-0"
                 style="left: 0">
              <mat-icon (click)="onSelectedItemRemoveClicked($index)"
                        class="close-icon cursor-pointer">close
              </mat-icon>
            </div>
            <div class="d-flex align-items-center">
              <p class="mb-0">{{ selectedOption ? (selectedOption.Custom) : '' }}</p>
            </div>
          </div>
        }
      </div>
      @if (isSearchable) {
        <div class="w-100 p-0 search-key">
          <span>
            {{ 'SearchOn' | translate }}:
          </span>
          @for (searchKey of getSearchOnKey(); track $index) {
            <div (click)="onSearchKeyClicked(searchKey)"
                 [ngClass]="searchKey === selectedSearchKey ? 'active' : ''"
                 class="text-wrapper">
              {{ getSearchKeyLabel(searchKey) | translate }}
            </div>
          }
          <div class="w-100 d-flex justify-content-center align-items-center search-icon-dropdown">
            <img src="/icons/ic_search.svg">
            <input (click)="$event.stopPropagation()"
                   (keyup)="onQuerySubmitted($event)"
                   [(ngModel)]="searchInput"
                   autofocus
                   class="w-100"
                   placeholder="{{'Search' | translate}}"
                   type="text">
          </div>
        </div>
      }
      @for (item of options; track $index) {
        <mat-option (click)="onItemSelected($index)"
                    [ngClass]="hasSelected(item) ? 'selected' : 'un-selected'"
                    [title]="item.Custom "
                    [value]="item[fieldName!]">{{ item.Custom }}
        </mat-option>
      } @empty {
        <mat-option [disabled]="true">{{ 'DataNotFound' | translate }}</mat-option>
      }
    </mat-select>
    @if (dropDownControl.errors?.['required']) {
      <mat-error>{{ 'IsFieldRequired' | translate }}</mat-error>
    }
  </mat-form-field>
</div>
